import { TNAV_LINK_STRUCTURE } from '../../../Navbar/ClearNavbar/types';
import { THeaderLabels } from './DropdownData';
interface DropdownLanguageData {
  [key: string]: {
    aboutUs: TNAV_LINK_STRUCTURE[];
    resources: TNAV_LINK_STRUCTURE[];
  };
}
interface mobileproperties {
  pageLang: string;
  header_labels: THeaderLabels;
  DropdownLanguageData: DropdownLanguageData;
  SA_SOLUTIONS_OPTIONS: TNAV_LINK_STRUCTURE[];
}
const SA_ABOUT_US: TNAV_LINK_STRUCTURE[] = [
  {
    name: '',
    url: '',
    child: [
      {
        id: 'company',
        title: 'Company',
        url: 'https://www.cleartax.com/sa/about-us',
      },
      {
        id: 'customer',
        title: 'Customers',
        url: 'https://www.cleartax.com/sa/customers',
      },
      {
        id: 'press',
        title: 'Press',
        url: 'https://www.cleartax.com/sa/press',
      },
    ],
  },
];

const SA_ABOUT_US_AR = [
  {
    name: '',
    url: '',
    child: [
      {
        id: 'company',
        title: 'شركة',

        url: 'https://www.cleartax.com/sa/about-us',
      },
      {
        id: 'customer',
        title: 'عملاء',
        url: 'https://www.cleartax.com/sa/customers',
      },
      {
        id: 'press',
        title: 'الأخبار',
        url: 'https://www.cleartax.com/sa/press',
      },
    ],
  },
];

export const SA_SOLUTIONS_OPTIONS = [
  {
    name: 'INDIVIDUAL PRODUCTS',
    url: '',
    child: [
      {
        id: 'invoicing Software',
        title: 'E-invoicing Software',
        url: 'https://www.cleartax.com/sa/e-invoicing-software',
      },
      {
        id: 'Api  integration',
        title: 'API Integration',
        url: 'https://www.cleartax.com/sa/e-invoicing-integration',
      },
      {
        id: 'vat automation',
        title: 'VAT Automation',
        url: 'https://www.cleartax.com/sa/vat-reconciliation-software',
      },
      {
        id: 'accounts payable',
        title: 'Accounts Payable Automation',
        url: 'https://www.cleartax.com/sa/ap-automation-software',
      },
      {
        id: 'ui based',
        title: 'UI-Based Invoice Creation',
        url: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
      },
      {
        id: 'e-invoice',
        title: 'E-Invoice Presentment & Payment Tracking',
        url: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
      },
      {
        id: 'notice management',
        title: 'Notice management',
        url: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
      },
      {
        id: 'accounts receivable and vendor portal',
        title: 'Accounts Receivables & Vendor Portal',
        url: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
      },
      {
        id: 'supply chain',
        title: 'Supply Chain Financing',
        url: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
      },
    ],
  },
  {
    name: 'ENTITIES',
    url: '',
    child: [
      {
        id: 'for businesses',
        title: 'For Businesses',
        url: 'https://www.cleartax.com/sa/business',
      },
      {
        id: 'for partners',
        title: 'For Partners',
        url: 'https://www.cleartax.com/sa/partners',
      },
    ],
  },
];

const SA_SOLUTIONS_OPTIONS_AR = [
  {
    name: 'INDIVIDUAL PRODUCTS',
    url: '',
    child: [
      {
        id: 'E-invoicing Software',
        title: 'برنامج الفوترة الإلكترونية',
        url: 'https://www.cleartax.com/sa/e-invoicing-software',
      },
      {
        id: 'API Integration',
        title: 'تكامل API',
        url: 'https://www.cleartax.com/sa/e-invoicing-integration',
      },
      {
        id: 'VAT Automation',
        title: 'أتمتة ضريبة القيمة المضافة',
        url: 'https://www.cleartax.com/sa/vat-reconciliation-software',
      },
      {
        id: 'Accounts Payable Automation',
        title: 'الحسابات الأتمتة المستحقة الدفع',
        url: 'https://www.cleartax.com/sa/ap-automation-software',
      },
      {
        id: 'UI-Based Invoice Creation',
        title: 'إنشاء الفاتورة على أساس واجهة المستخدم',
        url: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
      },
      {
        id: 'E-Invoice Presentment & Payment Tracking',
        title: 'عرض الفاتورة الإلكترونية وتتبع الدفع',
        url: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
      },
      {
        id: 'Notice management',
        title: 'أتمتة الحسابات المدينة',
        url: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
      },
      {
        id: 'Accounts Receivables & Vendor Portal',
        title: 'حساب المستحقات وبوابة البائع',
        url: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
      },
      {
        id: 'Supply Chain Financing',
        title: 'تمويل سلسلة التوريد',
        url: 'https://www.cleartax.com/sa#ksa-einvoicing-promises',
      },
    ],
  },
  {
    name: 'ENTITIES',
    url: '',
    child: [
      {
        id: 'For Businesses',
        title: 'للأعمال',
        url: 'https://www.cleartax.com/sa/business',
      },
      {
        id: 'For Partners',
        title: 'للشركاء فقط',
        url: 'https://www.cleartax.com/sa/partners',
      },
    ],
  },
];

const SA_RESOURCES_DATA: TNAV_LINK_STRUCTURE[] = [
  {
    name: '',
    url: '',
    child: [
      {
        id: 'webinars',
        title: 'Webinars',
        url: 'https://7giy8.app.link/e/xhv1Sw085sb',
      },
      {
        id: 'blog',
        title: 'Blog',
        url: 'https://www.cleartax.com/sa/ksa-einvoicing',
      },
      {
        id: 'case Studies',
        title: 'Case Studies',
        url: 'https://www.cleartax.com/sa/ksa-case-studies',
      },
    ],
  },
];

const SA_RESOURCES_DATA_AR = [
  {
    name: '',
    url: '',
    child: [
      {
        id: 'Webinars',
        title: 'ندوات عبر الإنترنت',
        url: 'https://7giy8.app.link/e/xhv1Sw085sb',
      },
      {
        id: 'Blog',
        title: 'المدونات',
        url: 'https://www.cleartax.com/sa/ksa-einvoicing',
      },
      {
        id: 'Case Studies',
        title: 'دراسات الحالة',
        url: 'https://www.cleartax.com/sa/ksa-case-studies',
      },
    ],
  },
];

export const DropdownLanguageData = {
  English: {
    aboutUs: SA_ABOUT_US,
    resources: SA_RESOURCES_DATA,
  },
  Arabic: {
    aboutUs: SA_ABOUT_US_AR,
    resources: SA_RESOURCES_DATA_AR,
  },
};
export const getMobileDropdownData = ({
  pageLang,
  header_labels,
  DropdownLanguageData,
  SA_SOLUTIONS_OPTIONS,
}: mobileproperties) => {
  const MobileDropdowndata = [
    {
      label: header_labels.about_us,
      list: DropdownLanguageData[pageLang]?.aboutUs || [],
    },
    { label: header_labels.solutions, list: SA_SOLUTIONS_OPTIONS },
    {
      label: header_labels.sa_resources,
      list: DropdownLanguageData[pageLang]?.resources || [],
    },
  ];
  return MobileDropdowndata;
};
